import {
  computed
} from "vue";

import posState from "./posState";

const {
  state
} = posState;

const filteredProducts =
  computed(() => {
    let products =
      Array.isArray(
        state.products
      )
        ? state.products
        : [];

    if (
      state.selectedCategoryId
    ) {
      products =
        products.filter(
          product =>
            Number(
              product.categoryId
            ) ===
            Number(
              state.selectedCategoryId
            )
        );
    }

    const query =
      String(
        state.searchText || ""
      )
        .trim()
        .toLowerCase();

    if (!query) {
      return products;
    }

    return products.filter(
      product => {
        const searchable =
          [
            product.itemCode,
            product.itemName,
            product.description,
            product.uom
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

        return searchable.includes(
          query
        );
      }
    );
  });

function setProducts(
  products
) {
  state.products =
    Array.isArray(
      products
    )
      ? products
      : [];
}

function setCategories(
  categories
) {
  state.categories =
    Array.isArray(
      categories
    )
      ? categories
      : [];
}

function selectCategory(
  categoryId
) {
  state.selectedCategoryId =
    categoryId ?? null;
}

function setSearchText(
  value
) {
  state.searchText =
    value ?? "";
}

function clearSearch() {
  state.searchText = "";
}

export default {
  filteredProducts,

  setProducts,
  setCategories,

  selectCategory,

  setSearchText,
  clearSearch
};